import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  pageTitleNSearchStylesHelper: {
    padding: "0 1.5rem",
    marginTop: "1.5rem",
  },
  Select: {
    "& ul": {
      maxHeight: "20vh",
    },
  },
  paginationHelper: {
    marginLeft: "auto",
  },
  gridStyle: { paddingTop: 40 },
  customTabBtmBorder: {
    borderBottom: "1px solid #CFD3DB",
    width: "90%",
  },
  deleteButtonHelper: {
    color: "#CF3537",
    padding: 0,
    textDecoration: "underline !important",
    fontWeight: "400 !important",
  },
  uploadAndShareContainer: {
    flex: 1,
    flexDirection: "column",
  },
  searchBoxHelper: {
    paddingLeft: "50rem",
    paddingRight: "7rem",
    marginTop: "1.5rem",
  },
});
